// src/pages/Aydinlatma_Metni.jsx
import React from "react";

const Aydinlatma_Metni = () => {
  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <h1 style={styles.title}>KİŞİSEL VERİLERİN KORUNMASI AYDINLATMA METNİ</h1>

        <section style={styles.section}>
          <p style={styles.text}>
            Von Dijital Yazılım Hizmetleri LTD. ŞTİ. (“Von Dijital” veya “Şirket”)
            olarak, işlettiğimiz{" "}
            <strong>www.temelden.com.tr</strong> internet sitesi ve ilgili dijital platform
            ziyaretçilerinin gizliliği ile kişisel verilerinin korunması, önceliklerimiz arasında
            yer almaktadır.
          </p>
          <p style={styles.text}>
            Bu Aydınlatma Metni; 6698 sayılı{" "}
            <strong>Kişisel Verilerin Korunması Kanunu (“KVKK”)</strong> uyarınca, veri sorumlusu
            sıfatıyla Şirketimiz tarafından kişisel verilerin nasıl işlendiği, hangi amaçlarla
            toplandığı, kimlere ve hangi amaçlarla aktarılabileceği konularında bilgilendirme
            amacıyla hazırlanmıştır.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>1. Veri Sorumlusu</h2>
          <p style={styles.text}>
            <strong>Von Dijital Yazılım Hizmetleri LTD. ŞTİ.</strong>
            <br />
            Adres: Göztepe Mah. Mithatpaşa Cad. Gürsoy No: 856/1B Konak/İzmir
            <br />
            E-posta: <a href="mailto:info@vondigital.com.tr" style={styles.link}>info@vondigital.com.tr</a>
            <br />
            Web: <a href="https://www.vondigital.com.tr" style={styles.link}>www.vondigital.com.tr</a>
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>2. Kişisel Verilerin İşlenme Amaçları</h2>
          <p style={styles.text}>
            Toplanan kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:
          </p>
          <ul style={styles.list}>
            <li>Platform hizmetlerinden yararlanmanızın sağlanması,</li>
            <li>İletişim taleplerinizin yanıtlanması,</li>
            <li>Üyelik ve kullanıcı işlemlerinizin yürütülmesi,</li>
            <li>Kullanıcı deneyiminin iyileştirilmesi,</li>
            <li>Veri güvenliği süreçlerinin yürütülmesi,</li>
            <li>Yasal yükümlülüklerin yerine getirilmesi.</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>3. Kişisel Verilerin Aktarılması</h2>
          <p style={styles.text}>
            Kişisel verileriniz; yalnızca hukuken yetkili kamu kurumları, iş ortakları ve hizmet
            sağlayıcılar ile, belirtilen amaçlarla sınırlı olmak üzere ve KVKK’nın 8. ve 9.
            maddelerine uygun şekilde paylaşılabilir.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>4. Kişisel Verilerin Toplanma Yöntemi ve Hukuki Sebebi</h2>
          <p style={styles.text}>
            Verileriniz; web sitesi formları, çerezler (cookies) ve kullanıcı etkileşimleri
            aracılığıyla toplanmaktadır. Bu veriler şu hukuki sebeplerle işlenmektedir:
          </p>
          <ul style={styles.list}>
            <li>KVKK m.5/2 (c): Sözleşmenin kurulması veya ifası için gerekli olması,</li>
            <li>KVKK m.5/2 (f): Meşru menfaatlerimiz kapsamında veri işlenmesinin zorunlu olması.</li>
          </ul>
          <p style={styles.text}>
            Çerezler hakkında detaylı bilgi için{" "}
            <a href="/cerez_politikasi" style={styles.link}>Çerez Politikamızı</a> inceleyebilirsiniz.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>5. KVKK Kapsamındaki Haklarınız</h2>
          <p style={styles.text}>
            KVKK’nın 11. maddesi uyarınca, Şirketimize başvurarak aşağıdaki haklara sahipsiniz:
          </p>
          <ul style={styles.list}>
            <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme,</li>
            <li>İşlenmişse buna ilişkin bilgi talep etme,</li>
            <li>Amacına uygun kullanılıp kullanılmadığını öğrenme,</li>
            <li>Eksik veya yanlış işlenmişse düzeltilmesini talep etme,</li>
            <li>Silinmesini veya yok edilmesini isteme,</li>
            <li>Bu işlemlerin aktarıldığı üçüncü kişilere bildirilmesini talep etme,</li>
            <li>İşleme sonucu aleyhinize bir sonucun ortaya çıkması hâlinde itiraz etme,</li>
            <li>Kanuna aykırı işlem nedeniyle zararınızın giderilmesini isteme.</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>6. Başvuru Yöntemi</h2>
          <p style={styles.text}>
            Başvurularınızı, <strong>“Veri Sorumlusuna Başvuru Usul ve Esasları Hakkında Tebliğ”</strong>
            uyarınca, yazılı olarak veya Kayıtlı Elektronik Posta (KEP) adresi üzerinden Şirketimize
            iletebilirsiniz. Talepleriniz en geç 30 gün içerisinde sonuçlandırılacaktır.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>7. Şikâyet Hakkı</h2>
          <p style={styles.text}>
            Başvurularınıza süresinde yanıt verilmemesi veya verilen cevabın yetersiz bulunması
            hâlinde, <strong>Kişisel Verileri Koruma Kurulu’na</strong> şikâyette bulunabilirsiniz.
          </p>
        </section>

        <section style={styles.section}>
          <p style={styles.text}>
            <strong>Verilerinizin güvenliği bizim için önemlidir.</strong> Bize duyduğunuz güven için teşekkür ederiz.
          </p>
          <p style={styles.text}>
            Von Dijital Hizmetler Pazarlama ve Ticaret LTD. ŞTİ.
            <br />
            <a href="https://www.temelden.com.tr" style={styles.link}>
              www.temelden.com.tr
            </a>
          </p>
        </section>
      </div>
    </div>
  );
};

const styles = {
  page: {
    backgroundColor: "#f7f7f7",
    minHeight: "100vh",
    padding: "60px 20px",
    display: "flex",
    justifyContent: "center",
  },
  container: {
    maxWidth: "900px",
    backgroundColor: "#fff",
    borderRadius: "12px",
    padding: "40px 30px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
    lineHeight: "1.7",
  },
  title: {
    fontSize: "24px",
    fontWeight: "700",
    textAlign: "center",
    marginBottom: "30px",
    color: "#222",
  },
  section: {
    marginBottom: "25px",
  },
  heading: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#333",
    marginBottom: "8px",
  },
  text: {
    fontSize: "14px",
    color: "#555",
    marginBottom: "10px",
  },
  list: {
    paddingLeft: "20px",
    color: "#555",
    fontSize: "14px",
    marginBottom: "10px",
  },
  link: {
    color: "#0056b3",
    textDecoration: "none",
  },
};

export default Aydinlatma_Metni;
